export interface IBonusCardLayout {
    x: number;
    y: number;
    angle: number;
    dealSequence: number;
    explodeSequence: number;
}

export default class BonusCardsLayoutDataHelper {
    public static getLayoutList(
        layoutData: any,
        stackCount: number
    ): IBonusCardLayout[][] {
        const layouts: IBonusCardLayout[][] = [];
        let cardsInStackCount = stackCount;
        while (cardsInStackCount > 0) {
            const index = (cardsInStackCount - 1) % layoutData.length;
            layouts.push(layoutData[index].slice(0));
            cardsInStackCount -= layoutData[index].length;
        }

        layouts.reverse();

        return layouts;
    }
}
